<mat-card>
  <app-card-header
    icono="assistant_navigation"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="!!dialogRef"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Content -->
      <mat-card-content
        [class.cardContentDialog]="dialogRef"
        [class.cardContentFullscreen]="!dialogRef && !subtitle"
        [class.cardContentFullscreenSubtitle]="!dialogRef && subtitle"
        class="card-content-crear"
      >
        <!-- Identificación -->
        <app-content-card
          title="Identificación del Activo"
          icon="badge"
          color="blue"
        >
          <section class="inputs-group">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="no-hint">
                <mat-label>Identificación</mat-label>
                <input
                  matInput
                  formControlName="identificacion"
                  [errorStateMatcher]="chequeo.matcher"
                />
                <mat-icon matPrefix>badge</mat-icon>
              </mat-form-field>
              <app-mensaje-identificacion
                [chequeo]="chequeo"
              ></app-mensaje-identificacion>
            </div>
          </section>
        </app-content-card>

        <!-- Cliente y Jerarquía -->
        <app-content-card
          title="Cliente y Atención de Eventos"
          icon="business"
          color="orange"
        >
          <div class="client-section-wrapper">
            <div class="client-fields">
              <section class="inputs-group">
                <!-- Cliente -->
                @if (mostrarCamposCliente && !data?.edit?._id) {
                  <div style="width: 100%">
                    <label class="field-label">Cliente Propietario</label>
                    <div style="display: flex; gap: 8px">
                      <app-cliente-selector
                        formControlName="idCliente"
                        style="flex: 1"
                        [filterModules]="['moduloActivos']"
                        [showCrearBtn]="
                          helper.tienePermiso('Administración - Crear clientes')
                        "
                      ></app-cliente-selector>
                    </div>
                  </div>
                }

                <!-- Horarios de atención -->
                <div style="width: 100%">
                  <app-config-horarios-atencion
                    formControlName="configHorariosAtencion"
                    [idClienteFinal]="idCliente"
                  ></app-config-horarios-atencion>
                </div>

                <!-- Horarios de atención técnica -->
                <div style="width: 100%">
                  <app-config-horarios-atencion
                    formControlName="configHorariosAtencionTecnica"
                    titulo="Clientes que Atienden Servicios Técnicos"
                    [idClienteFinal]="idCliente"
                  ></app-config-horarios-atencion>
                </div>

                <!-- Puede solicitar servicio técnico -->
                <mat-checkbox
                  color="primary"
                  formControlName="puedeSolicitarServicioTecnico"
                >
                  Puede solicitar servicio técnico (permite que el cliente
                  genere solicitudes de servicio técnico desde su app)
                </mat-checkbox>
              </section>
            </div>

            <!-- Gráfico de jerarquía de clientes -->
            @if (idCliente) {
              <div class="client-hierarchy">
                <app-jerarquia-cliente
                  [idCliente]="idCliente"
                ></app-jerarquia-cliente>
              </div>
            }
          </div>
        </app-content-card>

        <!-- Tracker y Grupo -->
        <app-content-card
          title="Tracker y Agrupación"
          icon="gps_fixed"
          color="green"
        >
          <section class="inputs-group">
            <!-- Tracker -->
            <div style="width: 100%; display: flex; gap: 8px">
              <ng-select
                [fixedPlaceholder]="true"
                [items]="trackers"
                bindLabel="nombre"
                bindValue="_id"
                formControlName="idTracker"
                placeholder="Tracker"
                [notFoundText]="'No hay Trackers disponibles'"
                style="flex: 1"
                multiple="false"
                searchable="true"
                appendTo="body"
              ></ng-select>
              <app-button
                [disabled]="!this.form.value.idCliente"
                matType="mat-fab"
                color="primary"
                icon="add"
                [tooltip]="'Crear tracker'"
                (click)="this.form.value.idCliente ? crearTracker() : null"
              ></app-button>
            </div>

            <!-- Grupo -->
            <app-grupo-selector
              formControlName="idGrupo"
              [idCliente]="form?.value?.idCliente"
              categoria="Activo"
              [showCrearBtn]="
                helper.tienePermiso('Activos - Crear agrupaciones')
              "
            ></app-grupo-selector>
          </section>

          <!-- Dashcam: independiente del tracker (puede tener los dos) -->
          <section class="inputs-group">
            <div style="width: 100%; display: flex; gap: 8px">
              <ng-select
                [items]="dashcams"
                bindLabel="nombre"
                bindValue="_id"
                formControlName="idDashcam"
                placeholder="Dashcam"
                notFoundText="No hay dashcams disponibles"
                style="flex: 1"
                appendTo="body"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.nombre }}
                  @if (item.uniqueId) {
                    <small class="ng-option-client">{{ item.uniqueId }}</small>
                  }
                </ng-template>
              </ng-select>
              @if (helper.tienePermiso('Administración - Crear dashcams')) {
                <button
                  irxBotonIcono="borde"
                  tamano="campo"
                  tono="primario"
                  type="button"
                  tooltip="Crear dashcam"
                  [disabled]="!form.value.idCliente"
                  (click)="crearDashcam()"
                >
                  <mat-icon>add</mat-icon>
                </button>
              }
            </div>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="dialogRef.close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
